// extracted by mini-css-extract-plugin
export default {"scrollContainer":"TableProductWrapper_scrollContainer__p9qs7","gridContainer":"TableProductWrapper_gridContainer__tTs3o"};